<h4 mat-dialog-title><i class="fas fa-check-circle mr-1"></i> Privileges</h4>

<mat-dialog-content class="mat-typography">
    <table mat-table [dataSource]="dataSource" class="gridData" matSort>
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Privilege name</th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Privilege description</th>
            <td mat-cell *matCellDef="let element"> {{element.description}} </td>
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"> {{element.status}} </td>
        </ng-container>
        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Action</th>
            <td mat-cell *matCellDef="let element">
                <mat-slide-toggle class="example-margin" color="primary" [checked]="element.assigned"
                    (change)="onChange(element.id, $event.source.checked)">
                </mat-slide-toggle>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnHeader"></tr>
        <tr mat-row *matRowDef="let row; columns: columnHeader;"></tr>
    </table>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-light float-right" (click)="closeDialog()">
        <i class="fas fa-times mr-1"></i> Close</button>
</mat-dialog-actions>